import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import handleRequestError from '../../utils/handleRequestError';

const initialState = {
    isLoading: true,
    ftFuelTankOperations: [],
    filters: {
        startdate: null,
        enddate: null,
        operationtypeid: null,
        fueltankid: null,
        machineid: null,
    },
    error: '',
};

export const fetchFTFuelTankOperations = createAsyncThunk(
    'ftFuelTankOperations/fetchFTFuelTankOperations',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/fueltankoperation`, {
                params,
            });

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

// Portal "edit current reading / level" is written as an ADJUST operation (operationTypeId 14),
// so the server replay recomputes and it stays in the one authoritative ledger.
export const createFTFuelTankOperation = createAsyncThunk(
    'ftFuelTankOperations/createFTFuelTankOperation',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_HOST_API_KEY}/fueltankoperation`, data);

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

const ftFuelTankOperationsSlice = createSlice({
    name: 'ftFuelTankOperationsSlice',
    initialState,
    reducers: {
        setFilters(state, action) {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters(state) {
            state.filters = {
                ...state.filters,
                operationtypeid: null,
                fueltankid: null,
                machineid: null,
            };
        },
    },
    extraReducers(builder) {
        builder.addCase(fetchFTFuelTankOperations.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFTFuelTankOperations.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.ftFuelTankOperations = payload.data;
        });
        builder.addCase(fetchFTFuelTankOperations.rejected, (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        });
    },
});

export const { setFilters, resetFilters } = ftFuelTankOperationsSlice.actions;

export default ftFuelTankOperationsSlice.reducer;

export const selectFTFuelTankOperationsData = (state) => state.ftFuelTankOperations.ftFuelTankOperations;
export const selectFTFuelTankOperationsLoading = (state) => state.ftFuelTankOperations.isLoading;
export const selectFTFuelTankOperationsError = (state) => state.ftFuelTankOperations.error;
export const selectFTFuelTankOperationsFilters = (state) => state.ftFuelTankOperations.filters;
